import { Button, Menu } from '@mantine/core';
import { useGeneratePersona } from '../hooks/useGeneratePersona';
import { isTestDataEnabled } from '../isTestDataEnabled';

/**
 * FNP-1577: the visible, explicit action that generates test personas.
 *
 * Gated here rather than only at the mount site so that every place this button
 * is ever rendered inherits the gate, instead of each one having to remember to
 * ask. The personas page asks as well — that check is what a test can observe
 * (FNP-1027), and this one is what a future mount site cannot forget.
 *
 * ⚠️ RETURNS NULL IN PROD, and that is a convenience, not the control — see
 * `isTestDataEnabled`. Generation here still runs CLIENT-SIDE through the
 * ordinary create mutation, so unlike messages (FNP-1521) there is no deployed
 * topology behind it yet; moving it behind a stage-gated API mutation is the
 * second half of FNP-1577 and is tracked separately.
 */
export const GeneratePersonaButton = () => {
    const { generate } = useGeneratePersona();

    // Absent in prod, not merely disabled: a greyed-out control invites
    // someone to ask why, and the answer is that the capability does not
    // exist there at all.
    if (!isTestDataEnabled()) {
        return null;
    }

    return (
        <Menu withinPortal>
            <Menu.Target>
                <Button>Generate Persona</Button>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item onClick={() => generate(1)}>Generate 1</Menu.Item>
                <Menu.Item onClick={() => generate(2)}>Generate 2</Menu.Item>
                <Menu.Item onClick={() => generate(3)}>Generate 3</Menu.Item>
                <Menu.Item onClick={() => generate(5)}>Generate 5</Menu.Item>
                <Menu.Item onClick={() => generate(10)}>Generate 10</Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};
